import { Alert, Box } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Outlet, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Breadcrumb from '../../../components/Breadcrumb';
import {
  useExportSettingConfiguration,
  useGetSettingConfiguration,
} from '../../../hooks/api/use-arcgis-civil3d-setting-configurations.hook';

export const EditSettingConfiguration = () => {
  const { configurationSettingId } = useParams<{ configurationSettingId: string }>();

  const { settingConfiguration, error: settingConfigurationError } = useGetSettingConfiguration({
    settingConfigurationId: Number(configurationSettingId),
  });
  const [exportSettingConfiguation, { loading: exporting, error: exportError }] = useExportSettingConfiguration();

  const error = settingConfigurationError || exportError;

  return (
    <Box sx={{ height: '100%' }}>
      <Helmet title="ArcGIS - Civil 3D Data Editor" />
      <Box display="flex" flexDirection="column" sx={{ height: '100%', p: '0 12px' }}>
        <Box display="flex" sx={{ m: '10px 0' }}>
          <Breadcrumb
            items={[
              { text: 'ArcGIS - Civil 3D Data Editor ', url: '/arcgis-civil3d-data-editor' },
              { text: settingConfiguration?.name || '' },
            ]}
          />
          <Box flexGrow={1} />
          <LoadingButton
            color="primary"
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={() => exportSettingConfiguation({ settingConfigurationId: Number(configurationSettingId) })}
            loading={exporting}
          >
            Export
          </LoadingButton>
        </Box>
        {error ? <Alert severity="error"> {error.response?.data.message}</Alert> : null}
        <Outlet />
      </Box>
    </Box>
  );
};
